<template>
    <div class="maxW">
        <div id="charts1"></div>
    </div>
</template>

<script>
    import Echarts from "echarts";

    export default {
        name: "echarts",
        mounted() {
            // let option = {
            //         tooltip: {
            //             axisPointer: {
            //                 type: 'cross',
            //                 crossStyle: {
            //                     color: '#999'
            //                 }
            //             }
            //         },
            //         legend: {
            //             data:['出货次数','订单出货价值']
            //         },
            //         xAxis: [
            //             {
            //                 type: 'category',
            //                 data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            //                 axisPointer: {
            //                     type: 'shadow'
            //                 }
            //             }
            //         ],
            //         yAxis: [
            //             {
            //                 type: 'value',
            //                 name: '订单出货价值',
            //                 min: 0,
            //                 max: 500,
            //                 interval: 100,
            //                 axisLabel: {
            //                     formatter: '{value}'
            //                 }
            //             },
            //             {
            //                 type: 'value',
            //                 name: '出货次数',
            //                 min: 0,
            //                 max: 25,
            //                 interval: 5,
            //                 axisLabel: {
            //                     formatter: '{value}'
            //                 }
            //             }
            //         ],
            //         series: [
            //             {
            //                 name:'订单出货价值',
            //                 type:'line',
            //                 data:[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
            //                 itemStyle: {
            //                     color: "skyblue"
            //                 }
            //             },
            //             {
            //                 name:'出货次数',
            //                 type:'bar',
            //                 yAxisIndex: 1,
            //                 data:[2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
            //                 itemStyle: {
            //                     color: "#ccc"
            //                 }
            //             }
            //         ]
            //     };
            /* 客户页面的饼图 */
            let option = {
                tooltip: {
                    trigger: 'item',
                    /**
                     * @b name
                     * @c value
                     * @d angle
                     * */
                    formatter: "{b} : {c} ({d}%)"
                },
                series: [
                    {
                        type: 'pie',
                        radius: '45%',
                        center: ['50%', '50%'],
                        data: [
                            {
                                value: 450,
                                name: '支出费用总计',
                                label: {
                                    formatter: "{b} : {c} ({d}%)"
                                },
                                itemStyle: {
                                    color: "#ffd86e",
                                }
                            },
                            {
                                value: 550,
                                name: `收入费用总计`,
                                label: {
                                    formatter: "{b} : {c} ({d}%)"
                                },
                                itemStyle: {
                                    color: "#2db6f4"
                                }
                            },
                        ],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            /* 客户页面的月份柱状图 */
            // let option = {
            //     color: ['#49a9ee'],
            //     tooltip : {
            //         trigger: 'axis',
            //         axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            //             type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            //         }
            //     },
            //     grid: {
            //         left: '3%',
            //         right: '4%',
            //         bottom: '3%',
            //         containLabel: true
            //     },
            //     xAxis : [
            //         {
            //             type : 'category',
            //             data : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月',],
            //             axisTick: {
            //                 alignWithLabel: true
            //             }
            //         }
            //     ],
            //     yAxis : [
            //         {
            //             type : 'value'
            //         }
            //     ],
            //     series : [
            //         {
            //             name:'工单请求数',
            //             type:'bar',
            //             barWidth: '20%',
            //             data:[1, 3, 5, 2, 3, 1, 2],
            //         }
            //     ]
            // };

            /* 客户页面的季度柱状图 */
            // let option = {
            //     legend: {},
            //     tooltip: {},
            //     dataset: {
            //         source: [
            //             ['product', '实际收入', '差旅费', '配件费', '其他'],
            //             ['第一季度', 143.3, 85.8, 93.7, 40],
            //             ['第二季度', 83.1, 73.4, 55.1, 40],
            //             ['第三季度', 86.4, 65.2, 82.5, 40],
            //             ['第四季度', 72.4, 53.9, 39.1, 40]
            //         ],
            //         itemStyle: {
            //
            //         }
            //     },
            //     xAxis: {type: 'category'},
            //     yAxis: {},
            //     // Declare several bar series, each will be mapped
            //     // to a column of dataset.source by default.
            //     series: [
            //         {type: 'bar', color: "#49a9ee"},
            //         {type: 'bar', color: "#555555"},
            //         {type: 'bar', color: "#d9001b"},
            //         {type: 'bar', color: "#95f204"},
            //     ]
            // };

            /* 配件管理页面的折柱混合图 */
            // let option = {
            //     tooltip: {
            //         axisPointer: {
            //             type: 'cross',
            //             crossStyle: {
            //                 color: '#999'
            //             }
            //         }
            //     },
            //     legend: {
            //         data:['出货次数','订单出货价值']
            //     },
            //     xAxis: [
            //         {
            //             type: 'category',
            //             data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            //             axisPointer: {
            //                 type: 'shadow'
            //             }
            //         }
            //     ],
            //     yAxis: [
            //         {
            //             type: 'value',
            //             name: '订单出货价值',
            //             min: 0,
            //             max: 500,
            //             interval: 100,
            //             axisLabel: {
            //                 formatter: '{value}'
            //             }
            //         },
            //         {
            //             type: 'value',
            //             name: '出货次数',
            //             min: 0,
            //             max: 25,
            //             interval: 5,
            //             axisLabel: {
            //                 formatter: '{value}'
            //             }
            //         }
            //     ],
            //     series: [
            //         {
            //             name:'订单出货价值',
            //             type:'line',
            //             data:[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
            //             itemStyle: {
            //                 color: "skyblue"
            //             }
            //         },
            //         {
            //             name:'出货次数',
            //             type:'bar',
            //             yAxisIndex: 1,
            //             data:[2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
            //             itemStyle: {
            //                 color: "#ccc"
            //             }
            //         }
            //     ]
            // };

            // console.log(Echarts);
            let echarts = Echarts.init(document.getElementById("charts1"));
            echarts.setOption(option)
            console.log(echarts);

            /* 客户页面的饼图 */
            // let option = {
            //     tooltip: {
            //         trigger: 'item',
            //         /**
            //          * @b name
            //          * @c value
            //          * @d angle
            //          * */
            //         formatter: "{b} : {c} ({d}%)"
            //     },
            //     series: [
            //         {
            //             type: 'pie',
            //             radius: '65%',
            //             center: ['50%', '50%'],
            //             data: [
            //                 {
            //                     value: 450,
            //                     name: '支出费用总计',
            //                     label: {
            //                         formatter: "{b} : {c} ({d}%)"
            //                     },
            //                     itemStyle: {
            //                         color: "#ffd86e",
            //                     }
            //                 },
            //                 {
            //                     value: 550,
            //                     name: `收入费用总计`,
            //                     label: {
            //                         formatter: "{b} : {c} ({d}%)"
            //                     },
            //                     itemStyle: {
            //                         color: "#2db6f4"
            //                     }
            //                 },
            //             ],
            //             itemStyle: {
            //                 emphasis: {
            //                     shadowBlur: 10,
            //                     shadowOffsetX: 0,
            //                     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //                 }
            //             }
            //         }
            //     ]
            // };

            /* 客户页面的月份柱状图 */
            // let option = {
            //     color: ['#49a9ee'],
            //     tooltip : {
            //         trigger: 'axis',
            //         axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            //             type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            //         }
            //     },
            //     grid: {
            //         left: '3%',
            //         right: '4%',
            //         bottom: '3%',
            //         containLabel: true
            //     },
            //     xAxis : [
            //         {
            //             type : 'category',
            //             data : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月',],
            //             axisTick: {
            //                 alignWithLabel: true
            //             }
            //         }
            //     ],
            //     yAxis : [
            //         {
            //             type : 'value'
            //         }
            //     ],
            //     series : [
            //         {
            //             name:'工单请求数',
            //             type:'bar',
            //             barWidth: '20%',
            //             data:[1, 3, 5, 2, 3, 1, 2],
            //         }
            //     ]
            // };

            /* 客户页面的季度柱状图 */
            // let option = {
            //     legend: {},
            //     tooltip: {},
            //     dataset: {
            //         source: [
            //             ['product', '实际收入', '差旅费', '配件费', '其他'],
            //             ['第一季度', 143.3, 85.8, 93.7, 40],
            //             ['第二季度', 83.1, 73.4, 55.1, 40],
            //             ['第三季度', 86.4, 65.2, 82.5, 40],
            //             ['第四季度', 72.4, 53.9, 39.1, 40]
            //         ],
            //         itemStyle: {
            //
            //         }
            //     },
            //     xAxis: {type: 'category'},
            //     yAxis: {},
            //     // Declare several bar series, each will be mapped
            //     // to a column of dataset.source by default.
            //     series: [
            //         {type: 'bar', color: "#49a9ee"},
            //         {type: 'bar', color: "#555555"},
            //         {type: 'bar', color: "#d9001b"},
            //         {type: 'bar', color: "#95f204"},
            //     ]
            // };

            /* 配件管理页面的折柱混合图 */
            // let option = {
            //     tooltip: {
            //         axisPointer: {
            //             type: 'cross',
            //             crossStyle: {
            //                 color: '#999'
            //             }
            //         }
            //     },
            //     legend: {
            //         data:['出货次数','订单出货价值']
            //     },
            //     xAxis: [
            //         {
            //             type: 'category',
            //             data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            //             axisPointer: {
            //                 type: 'shadow'
            //             }
            //         }
            //     ],
            //     yAxis: [
            //         {
            //             type: 'value',
            //             name: '订单出货价值',
            //             min: 0,
            //             max: 500,
            //             interval: 100,
            //             axisLabel: {
            //                 formatter: '{value}'
            //             }
            //         },
            //         {
            //             type: 'value',
            //             name: '出货次数',
            //             min: 0,
            //             max: 25,
            //             interval: 5,
            //             axisLabel: {
            //                 formatter: '{value}'
            //             }
            //         }
            //     ],
            //     series: [
            //         {
            //             name:'订单出货价值',
            //             type:'line',
            //             data:[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
            //             itemStyle: {
            //                 color: "skyblue"
            //             }
            //         },
            //         {
            //             name:'出货次数',
            //             type:'bar',
            //             yAxisIndex: 1,
            //             data:[2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
            //             itemStyle: {
            //                 color: "#ccc"
            //             }
            //         }
            //     ]
            // };
        }
    }
</script>

<style scoped>
    .maxW{
        width: 50%;
    }
    #charts1 {
        height: 400px;
    }
</style>
